export type BehavioralFactorNoE = 'A' | 'B' | 'C' | 'D';
export type BehavioralFactor = BehavioralFactorNoE | 'E';
export type BehavioralFactorAndM = BehavioralFactorNoE | 'M';

export const ABCD: BehavioralFactorNoE[] = ['A', 'B', 'C', 'D'];
export const ABCDM: BehavioralFactorAndM[] = [...ABCD, 'M'];

export const behavioralFactorLabelMap: {
    [key: string]: {
        name: string;
        left: string;
        right: string;
    };
} = {
    A: {
        name: 'text.common-terms.dominance',
        left: 'label.common-terms.collaborative',
        right: 'label.common-terms.independent'
    },
    B: {
        name: 'text.common-terms.extraversion',
        left: 'label.common-terms.reserved',
        right: 'label.common-terms.sociable'
    },
    C: {
        name: 'text.common-terms.patience',
        left: 'label.common-terms.driving',
        right: 'label.common-terms.steady'
    },
    D: {
        name: 'text.common-terms.formality',
        left: 'label.common-terms.flexible',
        right: 'label.common-terms.precise'
    },
    E: {
        name: 'text.common-terms.objectivity',
        left: 'label.analytics.graphs.factore.subjective',
        right: 'label.analytics.graphs.factore.objective'
    }
};

export const behavioralFactorLabelList: {
    key: BehavioralFactor;
    left: string;
    right: string;
}[] = Object.keys(behavioralFactorLabelMap).map((factor) => {
    const entry = behavioralFactorLabelMap[factor];
    return {
        key: factor as BehavioralFactor,
        left: entry.left,
        right: entry.right
    };
});
